<script setup>
import { useI18n } from 'vue-i18n';
import {computed} from "vue";


const props = defineProps({
    data: Number,
});

const { locale, t } = useI18n();

const formattedValue = computed(() => {
    if (props.data == null) return '';
    return new Intl.NumberFormat(locale.value, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(props.data);
});
</script>

<template>
    <div v-if="data" class="d-flex align-items-center">
        <span class="info-badge d-inline-block">
          {{ t('components.dashboard.index.accumulatedValue') }}: {{ formattedValue }}
        </span>
    </div>
</template>



<style scoped>
.info-badge {
    font-size: 13px;
    color: var(--whiteColor);;
    margin-left: 10px;
    padding: 1px 8.3px;
    border-radius: 100px;
    background-color: var(--lightColor);
}
</style>
